import type { ReactNode } from 'react';

export const symbol_bungalow: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M310-120q-12.75 0-21.37-8.63Q280-137.25 280-150v-256l-45 72q-7 11-18.5 14t-22.39-3.84q-10.89-6.84-14-19Q177-355 184-366l271-433q5-7 11-10.5t14-3.5q8 0 14 3.5t11 10.5l271 433q7 11 3.91 23.1-3.09 12.1-13.91 18.9-11 6-22.5 3.5T725-334l-45-72v256q0 12.75-8.62 21.37Q662.75-120 650-120H310Zm30-60h110v-90q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v90h110v-322L480-726 340-502v322Zm0 0h280-280Zm118.5-238.68q-8.5-8.67-8.5-21.5 0-12.82 8.68-21.32 8.67-8.5 21.5-8.5 12.82 0 21.32 8.68 8.5 8.67 8.5 21.5 0 12.82-8.68 21.32-8.67 8.5-21.5 8.5-12.82 0-21.32-8.68Z"
		/>
	</svg>
);
